import * as React from 'react';

import { useSelector } from 'react-redux';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { ContentSection } from '../../components/ContentSection';
import { ChartPriceContainer } from '../Charts';
import { DynamicInfo } from '../../components/DynamicInfo';
import { getCategory, getChartsData } from '../../selectors';
import { getPriceTitle, getPriceDescription } from './utils';
import { EBlockInPageName } from '../../types/share';
import { trackBlockInPageViewed } from '../../tracking';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../constants/actionAfterViewed';

export function ContentPriceContainer() {
  const chartData = useSelector(getChartsData('prices'));
  const category = useSelector(getCategory);

  const title = getPriceTitle(category);
  const description = getPriceDescription(category);

  const trackViewed = React.useCallback(() => {
    trackBlockInPageViewed(EBlockInPageName.AveragePrice);
  }, []);

  if (chartData && chartData.block) {
    return (
      <ActionAfterViewed callback={trackViewed} timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}>
        <ContentSection
          title={title}
          description={description}
          mainContent={
            <DynamicInfo
              trend={chartData.block.trend}
              title={chartData.block.title}
              description={chartData.block.text}
            />
          }
          chart={<ChartPriceContainer />}
        />
      </ActionAfterViewed>
    );
  }

  return null;
}
